import api from './api'; // ajusta al path de tu instancia axios

const BASE = '/physical-inventories';

export const getAllPhysicalInventories = (storeId) =>
  api.get(BASE, { params: { storeId } }).then(r => r.data);

export const getPhysicalInventoryById = (id) =>
  api.get(`${BASE}/${id}`).then(r => r.data);

export const getProductsForPhysicalInventory = (storeId) =>
  api.get(`${BASE}/products`, { params: { storeId } }).then(r => r.data);

export const createPhysicalInventory = (data) =>
  api.post(BASE, data).then(r => r.data);

export const updatePhysicalInventory = (id, data) =>
  api.put(`${BASE}/${id}`, data).then(r => r.data);

export const toggleLockPhysicalInventory = (id) =>
  api.patch(`${BASE}/${id}/toggle-lock`).then(r => r.data);

export const deletePhysicalInventory = (id) =>
  api.delete(`${BASE}/${id}`).then(r => r.data);